import { APIClient } from '@frontend/api-utils';

export class CustomRoleJsonClient extends APIClient {
    public static readonly endpoint = '/authorization-api/json/v1';

    public static async fetchCustomRolesJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/custom-roles`);
        return await this.handleBlobResponse(response);
    }

    public static async fetchSingleCustomRoleJson(accountId: string, roleId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/custom-roles/${roleId}`);
        return await this.handleBlobResponse(response);
    }

    public static async postCustomRolesJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/custom-roles`, formData);
        return await this.handleBlobResponse(response);
    }
}
